export enum ActionTypes { 
  fetchData
}